export enum ActionTypes { 
  fetchData
}